import classes from './Chat.module.css'
import MessageLine from './messageLine/MessageLine';
import Transcript from './transcript/Transcript';
import Header from './header/Header'
import Sidebar from './sidebar/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import useBotsService from '../../services/bot/botService';
import { useEffect } from 'react';
import { toggle } from './sidebar/sidebarSlice';
import { useBotConfig } from '../../context/BotConfigContext';
import { ReactComponent as SidebarToggleIcon } from '../../assets/SidebarToggle.svg';
import sidebarHeaderClasses from './sidebar/SidebarHeader/SidebarHeader.module.css'

function Chat() {
    const sidebarState = useSelector(state => state.sidebar)
    const botService = useBotsService()
    const isMobile = useSelector(state => state.layout).isMobile
    const dispatch = useDispatch()
    const config = useBotConfig()
    const { texts } = useSelector(state => state.translate)
    const isPortalMobile = config?.isPortalMobile === true
    const showHistoryFab = isMobile && !sidebarState.isOpen

    useEffect(() => {
        botService.resetDraft();
        (async () => {
            const sessions = await botService.syncSessions({ restoreLast: false })
            const sessionCount = sessions?.length ?? 0
            console.log("sessions: " + sessionCount)
            if (isMobile) {
                dispatch(toggle({isOpen: false}))
            }
        })();
    }, [config?.botId, dispatch])

    let conversationClass = "Conversation"
    if (!sidebarState.isOpen) {
        conversationClass = "ConversationWide"
    }

    let converation = (
        <div className={classes[conversationClass]}>
            <Transcript/>
            <MessageLine/>
        </div>
    )
    if (sidebarState.isOpen && isMobile) {
        converation = null
    }

    const openHistory = () => {
        dispatch(toggle({ isOpen: true }))
    }

    return (
        <div className={[classes.Chat, isPortalMobile ? classes.PortalMobileChat : ''].filter(Boolean).join(' ')}>
            {showHistoryFab ?
                <div className={classes.PortalHistoryFabWrap}>
                    <button
                        type="button"
                        className={classes.PortalHistoryFab}
                        onClick={openHistory}
                        aria-label={texts.allConversations}
                    >
                        <SidebarToggleIcon className={sidebarHeaderClasses.ToggleIconExpanded} />
                    </button>
                </div>
                : null}
            <Header/>
            <div className={classes.Content}>
                {converation}
                <Sidebar/>
            </div>
        </div>
    );
}

export default Chat;
